import { Maximize2 } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconMaximize(props: Readonly<IconWrapperProps>) {
  return (
    <IconWrapper {...props}>
      <Maximize2 />
    </IconWrapper>
  );
}
